import { useSessionStorage } from 'react-use';

export const useChecklistValidationSwitch = (checklistId: string) => {
  return useSessionStorage(`axpxApp_isValidationEnabled_${checklistId}`, false);
};
